<template>
  <div class="com-appeal-info">
    <ul>
      <li v-for="(i,index) in list" :key="i.id">
        <!-- {{(list.length - index).toLocaleString('zh-u-nu-hanidec')}} -->
        <p class="header">第{{list.length - index}}次申诉
          <span v-if="index==0">(当前申诉)</span>
          <span v-else>(历史申诉)</span>
        </p>
        <InfoTit>基础信息</InfoTit>
        <div class='basic-info'>
          <ul>
            <li><span class="name">申诉信息：</span><span class="content">{{i.appealInfo}}</span></li>
            <li><span class="name">申诉时间：</span><span class="content">{{i.appealTime}}</span></li>
            <li class="file-flex"><span class="name">申诉附件：</span> <ComFileList class="file-list" :list='i.appealAttachments'  isDownload></ComFileList></li>
          </ul>
        </div>
        <InfoTit v-if="i.yrHandleResultCode!=0 && i.yrHandleResultCode!=4">单位审批</InfoTit>
        <div class='appeal-info' v-if="i.yrHandleResultCode!=0 && i.yrHandleResultCode!=4" >
          <!-- <ul v-if="i.swHandleResultCode!=0 && i.swHandleResultCode!=4">
            <li><span class="title">市委组织部</span></li>
            <li><span class="name">处理时间：</span><span class="content">{{i.swHandleTime}}</span></li>
            <li><span class="name">处理结果：</span><span class="content">{{i.swHandleResult}}</span></li>
            <li><span class="name">处理意见：</span><span class="content">{{i.swHandleOpinion}}</span></li>
            <li class="file-flex"><span class="name">处理附件：</span> <ComFileList class="file-list" :list='i.swHandleAttachments'  isDownload></ComFileList></li>
          </ul>
          <ul v-if="i.zgHandleResultCode!=0 && i.zgHandleResultCode!=4">
            <li><span class="title">主管单位</span></li>
            <li><span class="name">处理时间：</span><span class="content">{{i.zgHandleTime}}</span></li>
            <li><span class="name">处理结果：</span><span class="content">{{i.zgHandleResult}}</span></li>
            <li><span class="name">处理意见：</span><span class="content">{{i.zgHandleOpinion}}</span></li>
            <li class="file-flex"><span class="name">处理附件：</span> <ComFileList class="file-list" :list='i.zgHandleAttachments'  isDownload></ComFileList></li>
          </ul> -->
          <ul>
            <li><span class="title">用人单位</span></li>
            <li><span class="name">处理时间：</span><span class="content"  >{{i.yrHandleTime}}</span></li>
            <li><span class="name">处理结果：</span><span class="content">{{i.yrHandleResult}}</span></li>
            <li><span class="name">处理意见：</span><span class="content">{{i.yrHandleOpinion}}</span></li>
            <li class="file-flex"><span class="name">处理附件：</span> <ComFileList v-if="i.yrHandleResultCode!=4" class="file-list" :list='i.yrHandleAttachments'  isDownload></ComFileList></li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// import {appealDetail,getAppealDetail} from '@/api/appeal'
import ComFileList from '@/components/common/com-file-list';
import InfoTit from '@/components/tit/info-tit';
// 申诉过程
export default {
  name:'AppealInfo',
  components:{
    ComFileList,
    InfoTit
  },
  props:{
    // appeaId:{
    //   type:[String,Number]
    // },
    // postId:{
    //   type:[String,Number]
    // },
    // appealPersonId:{
    //   type:[String,Number]
    // },
    list:{
      type:Array,
      default:()=>[],
      required:true
    }
  },
  data(){
    return{
      // list:[],
      // list2:[{
      //   id:'1111',
      //   name:'材料提交错误，现在已经更新。',
      //   time:'2023-08-01',
      //   fileList:[
      //     {
      //       id:'111222',
      //       fileName: '234ji2343jie处理附件.pdf',
      //       fileSize: 134400
      //     },
      //     {
      //       id:'333',
      //       fileName: '新建文件.doc',
      //       fileSize: 13440222220
      //     },
      //     {
      //       id:'22111222',
      //       fileName: '234ji2343jie处理附件.xls',
      //       fileSize: 134400
      //     },
      //     {
      //       id:'31133',
      //       fileName: '新建文件.txt',
      //       fileSize: 1344220
      //     }, {
      //       id:'111222',
      //       fileName: '234ji2343jie处理附件.pdf',
      //       fileSize: 134400
      //     },
      //     {
      //       id:'333',
      //       fileName: '新建文件.doc',
      //       fileSize: 13440222220
      //     },
      //     {
      //       id:'22111222',
      //       fileName: '234ji2343jie处理附件.xls',
      //       fileSize: 134400
      //     },
      //     {
      //       id:'31133',
      //       fileName: '新建文件.txt',
      //       fileSize: 1344220
      //     },
      //   ],
      //   approveList:[{
      //     id:'1',
      //     name:'市委组织部',
      //     time:'2023-08-01',
      //     result:'受理',
      //     opinion:'无',
      //     fileList:[]
      //   },
      //     {
      //     id:'1',
      //     name:'主管单位',
      //     time:'2023-08-01',
      //     result:'受理',
      //     opinion:'无',
      //     fileList:[]
      //   },
      //     {
      //     id:'1',
      //     name:'用人单位',
      //     time:'2023-08-01',
      //     result:'受理',
      //     opinion:'无',
      //     fileList:[]
      //   }
      //   ]
      // },{
      //   id:'222',
      //   name:'申报填错了',
      //   time:'2023-07-21',
      //   fileList:[]
      // },
      // {
      //   id:'222',
      //   name:'申报填错了',
      //   time:'2023-07-21',
      //   fileList:[]
      // }]
    }
  },
  // mounted(){
  //   if(this.appeaId){
  //     this.getAppealById();
  //   }else if(this.postId&&this.appealPersonId){
  //     this.getCheckAppealDetail();
  //   }
  // },
  methods:{
    // getAppealById(){
    //   appealDetail(this.id).then((res)=>{
    //   if(res.code == 0){
    //     this.list=res.data;
    //     if(res.data.length>0){
    //       this.declarationReviewEntity=res.data[0].declarationReviewEntity;
    //       let code = res.data[0].yrHandleResultCode;
    //       if(code == 0 ||code == 4){
    //         this.isEdit = true;//用人审核未处理 显示编辑审核
    //       }
    //     }
        
    //   }
    // })
    // },
    // getCheckAppealDetail(){
    //   getAppealDetail({
    //     appealPersonId: this.appealPersonId,
    //     postId: this.postId
    //   }).then(res => {
    //     if (res.code == 0) {
    //       this.list = res.data;
    //       console.log('res');
    //       console.log(res);
    //     }
    //   });
    // }
  }
}
</script>

<style lang='less' scoped>
.com-appeal-info{
  padding: 0 16px 17px;
  background: #fff;
  .header{
    position: relative;
    display: block;
    margin-bottom: 25px;
    box-sizing: border-box;
    padding:0 20px;
    height: 40px;
    line-height: 40px; 
    color: #246C9B;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    border-radius: 5px;
    background-color: #F1F5F9;
    
  }
  .info-tit{
    margin-bottom:16px;
  }
  .file-flex{
    display: flex;
    justify-content: flex-start;
    .name{
      flex: 0 0 70px;
    }
    .file-list{
      flex: 1 0 1022px;
    }
  }
  .basic-info{
    padding-left: 16px;
    ul{
      li{
        margin-bottom: 4px;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        &:last-of-type{
          margin-bottom: 0;
        }
        .name{
          color:#505D6E;
        }
        .content{
          color: #111111;
        }
      }
    }
  }
  .appeal-info{
    ul{
      position: relative;
      margin-left: 34px;
      margin-bottom: 20px;
      padding:12px 12px 0;
      background: #F7F8FA;
      border-radius: 5px;
      &::after{
        position: absolute;
        content: '';
        width:6px;
        height: 6px;
        border-radius: 50%;
        background:#28B84A;
        left:-15px;
        top: 20px;
      }
      &::before{
        position: absolute;
        content: '';
        width:2px;
        height: calc(100% - 25px);
        background:#F7F7F7;
        left:-13px;
        top: 25px;
        z-index: 0;
      }
      li{
        margin-bottom: 4px;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        &:last-of-type{
          margin-bottom: 0;
        }
        .title{
          color: #111111;
          font-weight: 600;
        }
        .name{
          color:#505D6E;
        }
        .content{
          color: #111111;
        }
      }

    }
  }
}
</style>